import { useEffect, useRef, useState } from 'react'
import Popover from './Popover';

/**
 * Invite Component
 *
 * @param params
 * @returns {JSX.Element}
 * @constructor
 */
const Invite = (params) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const player = JSON.parse(localStorage.getItem('player'));
  const inviteLink = useRef('');

  /**
   * Validate player and set invite link.
   */
  useEffect(() => {
    // The stored player should always exist at this point
    if (player === null) {
      window.location = '/';
      return;
    }

    inviteLink.current = process.env.REACT_APP_BASE_URL + '/invitation/' + (player._id || player.temp_id) + '/' + params.groupGuid;
  }, [params.groupGuid, player]);

  /**
   * onPopoverClick
   *
   * Handler for when the popover is clicked. Closes the popover.
   *
   * @param event
   */
  const onPopoverClick = (event) => {
    setPopoverOpen(false);
  }

  /**
   * Copy invite link to clipboard.
   * Attempts to use the share API if available.
   *
   * @param event
   * @returns {Promise<void>}
   */
  const copyToClipboard = async (event) => {
    try {
      // Copy link to clipboard
      await navigator.clipboard.writeText(inviteLink.current);
      console.log('Invite link copied to clipboard: ', inviteLink.current);
      setPopoverOpen(!popoverOpen);

      if (navigator.share) {
        navigator.share({
          title: 'TrivAI Invitation',
          text: params.subject ? 'Up for some trivia about ' + params.subject + '?' : 'Up for some trivia?',
          url: inviteLink.current,
        })
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error));
      } else {
        console.log('Web Share API not supported');
      }
    } catch (err) {
      console.log('Failed to copy invite code: ', err);
    }
  };

  return (
    <div>
      <button className="main-btn invite-button" onClick={copyToClipboard}>Invite</button>
      {popoverOpen && <Popover text="Invite link copied to clipboard. Share this with your friends to invite them to your game." onClick={onPopoverClick}/>}
    </div>
  )
}

export default Invite;